<template>
  <div class="homepage-inquiries">
    <template-search-list
      :listApi="listApi"
      :buttonOption="buttonOption"
      :defaultSortBy="'-regDate'"
      :selected="selected"
      @select="setSelected"
      @showDetail="showDetail"
    />
    <template-detail
      v-if="apiParam"
      :key="apiParam.id"
      :infoApi="infoApi"
      :apiParam="apiParam"
      @close="closeDetail"
    />
  </div>
</template>

<script>
import { getInquiryList, getInquiryDetail } from '@/api/inquiry'
import TemplateSearchList from '@/components/_template/SearchList'
import TemplateDetail from '@/components/_template/Detail'

export default {
  name: 'HomepageInquiries',
  components: { TemplateSearchList, TemplateDetail },
  data () {
    return {
      selected: null,
      apiParam: null,
      listApi: getInquiryList,
      infoApi: getInquiryDetail,
      buttonOption: [{
        action: 'showDetail',
        columnText: '자세히',
        buttonText: '<i class="xi-arrow-right"></i>'
      }]
    }
  },
  methods: {
    setSelected (row) {
      this.selected = row
    },
    showDetail (row) {
      if (row && typeof row.id === 'string' && /^[a-f\d]{24}$/i.test(row.id)) {
        this.apiParam = { id: row.id }
      }
    },
    closeDetail () {
      this.apiParam = null
      this.selected = null
    }
  }
}
</script>
